import { IsString, Length, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class CreateAttemptStatusDto {
  @ApiProperty({ description: 'Code unique', example: 'SUBMITTED' })
  @IsString()
  @Length(2, 64)
  code!: string; // ex: CREATED, IN_PROGRESS, SUBMITTED, GRADED

  @ApiProperty({ description: 'Libellé', example: 'Soumise' })
  @IsString()
  @IsNotEmpty()
  label!: string;
}








